// extracted by mini-css-extract-plugin
module.exports = {"delta2_group4":"Group4_delta2_group4__sD0UY"};